exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-442f88ce{text-align:left;font-size:14px;line-height:20px;padding:10px 15px;width:100%;display:flex;flex-direction:row}.left-3e2e4ba6{flex:1 1 auto}.right-7eef597e{flex:1 0 100px;height:100px}\n", ""]);

// Exports
exports.locals = {
	"content": "content-442f88ce",
	"left": "left-3e2e4ba6",
	"right": "right-7eef597e"
};